import { NgModule } from "@angular/core";
import { RoleDetailsComponent } from "./role-details.component";
import { SharedModule } from "../../../core/shared/shared.module";
import { roleDetailsRouting } from "./role-details.routing";
import { RoleDetailsRest } from "./role-details.rest";
import { UserSelectionComponent } from '../user-selection/user-selection.component';

@NgModule({
    declarations: [
        RoleDetailsComponent,
        UserSelectionComponent
    ],
    imports: [SharedModule, roleDetailsRouting],
    exports: [UserSelectionComponent],
    providers: [RoleDetailsRest]
  })
  export class RoleDetailsModule { }